module.exports = __webpack_public_path__ + "media/images/icons/target-13db873b2aa87c9c5b08decee1532772.svg";